/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discount_codes_happy_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Šťastný nákup`
};

const da_discount_codes_happy_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `God shopping`
};

const de_discount_codes_happy_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Viel Spaß beim Einkaufen`
};

const en_discount_codes_happy_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Happy Shopping!`
};

const es_discount_codes_happy_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `¡Felices compras!`
};

const fr_discount_codes_happy_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Bon Shopping`
};

const hu_discount_codes_happy_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Boldog vásárlást`
};

const it_discount_codes_happy_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Buono shopping`
};

const nl_discount_codes_happy_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Veel winkelplezier`
};

const pl_discount_codes_happy_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Udanych zakupów`
};

const pt_discount_codes_happy_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Boas compras`
};

const sv_discount_codes_happy_shopping = /** @type {(inputs: {}) => string} */ () => {
	return `Trevlig shopping`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const discount_codes_happy_shopping = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discount_codes_happy_shopping(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discount_codes_happy_shopping", locale)
	if (locale === "cs") return cs_discount_codes_happy_shopping(inputs)
	if (locale === "da") return da_discount_codes_happy_shopping(inputs)
	if (locale === "de") return de_discount_codes_happy_shopping(inputs)
	if (locale === "en") return en_discount_codes_happy_shopping(inputs)
	if (locale === "es") return es_discount_codes_happy_shopping(inputs)
	if (locale === "fr") return fr_discount_codes_happy_shopping(inputs)
	if (locale === "hu") return hu_discount_codes_happy_shopping(inputs)
	if (locale === "it") return it_discount_codes_happy_shopping(inputs)
	if (locale === "nl") return nl_discount_codes_happy_shopping(inputs)
	if (locale === "pl") return pl_discount_codes_happy_shopping(inputs)
	if (locale === "pt") return pt_discount_codes_happy_shopping(inputs)
	return sv_discount_codes_happy_shopping(inputs)
};
export { discount_codes_happy_shopping as "discount_codes.happy_shopping" }